import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../component-store'
import * as fields from '../fields'

/**
 * Displays a survey component
 */
@ngCore.Component({
  imports: [fields.Component, ds.layout.section.Component],
  selector: 'atn-mosaic-survey',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.Widget} */
  private readonly _widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.Questions>,
  )
  /**
   * Fields to be passed to field component. Can be with or without section
   */
  // NOTE: Right now component supports a field collection without sections. In future we
  // probably want to support sections. If we were to pass WithSections type the
  // app would show empty widget, but it wouldn't break
  public readonly fieldsSg = ngCore.computed(
    (content = this._widgetStore.contentSg()) => content?.fields ?? [],
  )

  /** @see {@link ents.core.display.Field.Collection.WithSections} */
  private readonly _sectionsWithFieldsSg = ngCore.computed(
    (sections = this._widgetStore.contentSg()?.sections) => sections ?? [],
  )

  /**
   * Computed signal for sections with fields, where each section includes the `startFrom` property.
   * The `startFrom` indicates the starting index of each section's ordered list of fields,
   * incremented cumulatively by the number of fields in previous sections.
   *
   * Based on {@link ents.core.display.Field.Collection.WithSections}
   */
  public readonly sectionsWithNumberedFieldsSg = ngCore.computed(
    (sectionsWithFields = this._sectionsWithFieldsSg()) => {
      let orderCounter = 1

      return sectionsWithFields.map(section => {
        const newSection = {
          ...section,
          startFrom: orderCounter,
        }

        orderCounter += section.fields?.length ?? 0

        return newSection
      })
    },
  )

  constructor() {
    // NOTE: Initialize field collection values early to ensure correct values
    // are available for DMS mutations, preventing null/undefined values, when
    // fields are not touched.
    ngCore.effect(() => {
      const _fields = this.fieldsSg()
      for (const { id, value } of _fields) {
        if (id) {
          this._widgetStore.fieldCollection.setFieldValue(id, value)
        }
      }
    })
  }

  // TODO: Will probably be moved into lower level component when sections are
  // implemented. See Details component.
  /**
   * Setting field value in field collection upon field value change so that it
   * could be accessed upon editing/creating new entity through details
   */
  public fieldValueChangeHandler(
    value: unknown,
    /**
     * NOTE: id parameter is optional to support {@link ents.core.display.Field.readonly}
     * fields, which may not require an id when displayed in readonly mode
     */
    id?: ents.core.display.Field.Id,
  ) {
    // check for undefined explicitly to handle falsy values correctly
    if (id !== undefined) {
      this._widgetStore.fieldCollection.setFieldValue(id, value)
    }
  }
}
